// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__D4fPB","dragIcon":"Choice_dragIcon__hnTId","left":"Choice_left__1kSIe","input":"Choice_input__NjysQ"};